<template>
    <div class="page white_bg">
        <div style="height: 46px;">
            <header class="pageHeader detailPageHeader white_bg paddingH16 paddingV8" style="line-height: 30px;">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;"
                                  @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="height: 30px; overflow: hidden">
                            {{ title }}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body">

            <personalHeader :userInfo="dataItem"/>

            <div class="font14r clearfix" style="padding: 0 12px 0 30px; line-height: 35px;">
                <span>费用余额：</span>
                <span class="orange2 floatR" >{{ dataItem ? dataItem.balance : '??' }}元</span>
            </div>

            <div class="lightGreyLine"></div>

            <div class="padding20">
                <div class="bgFAFAFA padding8 roundBorder4 font12r">
                    <span class="color101010">我的账户费用：{{ dataItem ? dataItem.balance : '??' }}元</span>
                    <router-link class="grey60 floatR" :to="{name:'agencyLogList'}">充值明细 &gt;</router-link>
                </div>
                <div class="bgLightGrey padding8 roundBorder4 marginT24">
                    <input type="text" class="block w100p noBorder noBg noPadding font14r" style="line-height: 36px;"
                           placeholder="请输入代理商账号（邀请码）进行充值"/>
                </div>

                <div class="marginT24">
                    <div class="titleArea">
                        <span class="font14r grey20 bold">充值数额</span>
                    </div>
                    <div class="optionsArea grid3column marginT16" style="grid-gap: 12px 11px;">
                        <div class="optionItem roundBorder8 alignC" :class="{active : activeOption == optionItem}"
                             v-for="(optionItem, index) in rechargeOptions" :key="index"
                             @click="selectOption(optionItem)">
                            <span class="font12r priceText">{{optionItem.value + '元'}}</span>
                        </div>
                    </div>
                </div>

                <!-- 选择协议 -->
                <div class="font13r generalPagePaddingH marginT16 alignCenter">
                    <label>
                        <input class="modernCheckbox" type="checkbox"
                               style="vertical-align: middle; margin: -2px 6px 0;"
                               :checked="agreeServiceProtocol" v-model="agreeServiceProtocol"/>
                        <span style="color: hsla(219, 9%, 39%, 1)">同意</span>
                        <router-link class="red" :to="agreeServiceUrl">
                            《{{agreeServiceName}}》
                        </router-link>
                    </label>
                </div>

                <div class="marginT12">
                    <button class="block centered alignCenter payButton bold noBorder white" v-on:click="pay()"
                            :disabled="status === 'loading'">
                        <i class="fa fa-spinner rotate" v-if="status === 'loading'" style="width:20px; height:20px"></i>
                        立即支付<span>{{ price }}元</span>
                    </button>
                </div>

            </div>

        </div>
        <div style="height: 51px;"></div>

        <payDialog ref="payDialog" type="agencyBalance" :onPaySuccess="onPaySuccess"
               agreeServiceName="师讯代理商开课充值服务协议"
               :agreeServiceUrl="agreeServiceUrl"/>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from "@/appConfig";

// modules
import personalHeader from "./personalHeaderWithoutRecharge";
import payDialog from "@comp/drawer/generalPayDialog";

import vipApi from '@/api/vip';
import VipTypeBroadSenseEnum from '@/data/VipTypeBroadSenseEnum';

// util
import appHelper    from '../../util/appHelper';
import userUtil     from "../shixunApp/userUtil";
import consoleHelper from "@util/consoleHelper";
import wechatHelper from "@util/wechatHelper";
import bizTypeEnum from "@data/bizTypeEnum";
import systemApi from '@/api/system';

const config = {
    apiConfig: {
        get: {
            url: 'portal/v2/distribution/agency/get/info',
            dataPath : 'data'
        }
    },
    agreeServiceName : '',
    agreeServiceUrl : '/help/agreement/AGENCY_RECHARGE_AGREEMENT',
};

export default {
    name: "agencyRecharge",
    extends: shixunPagePart,
    components: {
        personalHeader, payDialog
    },
    data() {
        return {
            title: '代理商个人中心',
            apiConfig: config.apiConfig,
            enableDataList: true,
            enableDataItem: true,
            tabModule: {
                activeIndex: 0
            },

            vipDueTime : '',
            vipEnjoyData : null,
            activeOption : null,
            agreeServiceProtocol: false,

            agreeServiceName : config.agreeServiceName || '师讯代理商开课充值服务协议',
            agreeServiceUrl  : config.agreeServiceUrl,

            price : 0,

            rechargeOptions : []
        }
    },
    methods: {
        back: function () {
            appHelper.goToPage('agencyPersonalCenter');
        },
        onLoadDataItem() {

            // log
            consoleHelper.log('');
            consoleHelper.log('代理商基本信息：');
            consoleHelper.log('-- 姓名：' + this.dataItem.userName);
            consoleHelper.log('-- 创建日期：' + this.formatDate(this.dataItem.createTime));
            consoleHelper.log('-- 有效期：' + this.formatDate(this.dataItem.expireTime));
            consoleHelper.log('-- 团队成员数：' + this.dataItem.teamSize);
            consoleHelper.log('-- 团队总收益：￥' + this.dataItem.totalIncome);

            // const wechatShareOptions = {
            //     title   : '邀请码+合伙人邀请你一起成为师讯会员，快去加入吧！',
            //     // desc    : this.description,
            //     link : appHelper.generateShareUrl('/auth/distributorAuth/promotion/:promotionCode', {
            //         ':promotionCode' : this.userInstance.introduceCode
            //     }),
            //     imgUrl  : appHelper.getAppIcon() // 分享图标
            // };
            // consoleHelper.log('');
            // consoleHelper.log('[wechat] wechatShareOptions:');
            // consoleHelper.log(wechatShareOptions);
            // wechatHelper.setShare(wechatShareOptions);

        },
        pay() {
            this.$refs.payDialog.setProduct({
                id      : this.activeOption.value,
                title   : '代理商开课充值',
                image   : appHelper.getAppIcon(),
                price   : this.activeOption.value
            })
            this.$refs.payDialog.show();

        },
        onPaySuccess: function (data) {
            let orderId = data.orderId;
            appHelper.showHint('充值成功');
            this.reloadDataItem();
        },
        selectOption(optionItem) {
            this.activeOption = optionItem;
            this.price = this.activeOption.value;
        }
    },
    mounted() {

        const me = this;

        this.loadDataItem();

        if (appConfig.mode == "demo") {
            // this.dataItem = {
            //     id: 1,
            //     certification : []
            // };
            //
            // for (let j = 0; j < 3; j++) {
            //     this.dataItem.certification.push(appHelper.getRandomCoverImage());
            // }

        }
        else
        {
            appHelper.needLogin((user) => {
                this.userInstance = userUtil.createUser(user);
                this.vipDueTime = user.vipDueTime['4'];
            });

            // for (let i=0.01; i<=0.06; i++)
            // {
            //     this.rechargeOptions.push({
            //         value : i
            //     });
            // }
            //
            // this.dataList = [{
            //     id : 1,
            //     value : 1000
            // }, {
            //     id : 2,
            //     value :2000
            // }, {
            //     id : 3,
            //     value : 3000
            // }, {
            //     id : 4,
            //     value : 4000
            // }, {
            //     id : 5,
            //     value : 5000
            // }, {
            //     id : 6,
            //     value : 0.01
            // }];

            this.activeOption = this.dataList[0];
        }

        vipApi.loadVipEnjoyInfo(VipTypeBroadSenseEnum.AGENCY.code, (result) => {
            me.vipEnjoyData = result.data;
        });

        systemApi.getConfig('agent_recharge', (result) => {

            let options = [];
            try {
                options = JSON.parse(result.data);
            }
            catch (e)
            {
                consoleHelper.logError(e);
                return;
            }

            this.rechargeOptions = options;
        })
    }
}
</script>

<style lang="scss" scoped>
.orange2 {
    color: #E99D42;
}
.red {
    color: #BD3124;
}
.optionsArea {
    .optionItem {
        background: hsla(0, 0%, 98%, 1);
        border: solid 1px transparent;
        box-sizing: border-box;
        padding: 13px 0;

        .countText {
            color: hsla(219, 9%, 39%, 1);
        }
        .priceText {
            color: hsla(219, 16%, 60%, 1);
        }

        &.active {
            background: #FFF8ED;
            border-color: hsla(36, 100%, 57%, 1);
            color: hsla(36, 100%, 57%, 1);

            .countText, .priceText {
                color: hsla(36, 100%, 57%, 1);
            }
        }
    }
}
.bgLightGrey {
    background: #F2F3F7;
}
.payButton {
    font-size: 100%;
    display: block;
    //width: 298px;
    width: 100%;
    margin: 0 auto;
    height: 2.625em;
    border-radius: 1.3125em;
    padding: 4px 0;
    line-height: 1.1em;

    background: linear-gradient(90deg, #FFA115 0%, #FFBF60 100%);
    // background: linear-gradient(168deg, #FF6434 0%, #FF3452 100%);
}
</style>
